export const AQUA_NETWORK_URL = 'https://aqua.network';
export const AQUA_DOCS_URL = 'https://docs.aqua.network/';
export const AQUA_DOCS_AUDIT = `${AQUA_DOCS_URL}technical-documents/audits`;

export const COINDISCO_WIDGET_URL = 'https://widget.coindisco.com/';
